export const UK_FIELDS = {
  crimes: {
    answer: {
      type: "yes-no-buttons"
    }
  }
}

export const UK_APPLICATION_FIELDS = {
  criminal_conviction_last_12months: {
    answer: {
      type: "yes-no-buttons"
    }
  },
  contact_parent: {
    type: "buttons",
    props: {
      options: [
        {
          label: "Mother/Parent 1",
          value: "mother"
        },
        {
          label: "Father/Parent 2",
          value: "father"
        }
      ]
    }
  },
  areas_to_visit: {
    type: "radio-button",
    defaultValue: "uk",
    props: {
      options: [
        {
          label: "United Kingdom",
          description: "Includes England, Scotland, Wales, and Northern Ireland",
          value: "uk"
        },
        {
          label: "Jersey",
          value: "jersey"
        },
        {
          label: "Guernsey",
          value: "guernsey"
        },
        {
          label: "Isle of Man",
          value: "isle_of_man"
        }
      ]
    }
  }
}